import React, { FunctionComponent, memo, useState } from 'react';
import MuteSvgUrl from '../../../assets/mute.svg';
import UnmuteSvgUrl from '../../../assets/unmute.svg';
import { bkgrAudio, IEntityActionTypes, useActionStateStore, sceneAudioManagerDict, useDataStore } from '../../../zustand';
import RoundButton from '../Primary/RoundButton/RoundButton';
import * as CSS from './SoundToggleButton.scss';
import { useGetCurrentSceneId } from '../../../hooks/general'
import { IPlaySoundAction, ISceneComp } from '../../r3f-components/component-data-structure';

const SoundToggleButton: FunctionComponent = () => {
	const entityActionDispatch = useActionStateStore(({ dispatch }) => dispatch);
	const [muted, setMuted] = useState(true);
	const [hasBeenToggled, setHasBeenToggled] = useState(false);
    const currentSceneId = useGetCurrentSceneId();
    const componentsById = useDataStore(({ componentsById }) => componentsById);
	const currentScene = componentsById?.[currentSceneId] as ISceneComp | undefined;

	const sceneHasStopMediaAction = !!currentScene?.actions?.onLoad?.find((action) => (action as IPlaySoundAction).stopMedia);


	return (
		<RoundButton
			className={CSS.BottomRight}
			onClick={() => {
				if (!hasBeenToggled) {
					// Only start background sound at the beginning
					if (!sceneHasStopMediaAction) {
						bkgrAudio.play()

						entityActionDispatch?.({
							type: IEntityActionTypes.PLAY_BACKGROUND_AUDIO,
						});
					} else {
						bkgrAudio.volume = 0;
						try {
							bkgrAudio.play().then(() =>{ 
								bkgrAudio.volume = 1;
								bkgrAudio.pause();
							})
						} catch (error) {
							console.warn(error)
						}
						
					};

					setHasBeenToggled(true);
					const sceneAudio = sceneAudioManagerDict[currentSceneId];
					sceneAudio.playAudio({entityIds: [currentSceneId], experienceIsMuted: false})
				}

				entityActionDispatch?.({
					type: muted ? IEntityActionTypes.UNMUTE_EXPERIENCE : IEntityActionTypes.MUTE_EXPERIENCE,
				});

				setMuted((prev) => !prev);
			}}
		>
			<img src={muted ? UnmuteSvgUrl : MuteSvgUrl} />
		</RoundButton>
	);
};

SoundToggleButton.displayName = 'SoundToggleButton';
export default memo(SoundToggleButton);
